import { ISearchRequestReferrer } from "@faire/web-api/indigofair/data/ISearchRequestReferrer";
import React, { lazy } from "react";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export interface IProps {
  relatedSearchTerms: string[];
  onRelatedSearchListView?: () => void;
  generateSearchTermUrl: (
    searchTerm: string,
    refType: ISearchRequestReferrer.SearchRequestReferrerType
  ) => string;
  onSearchTermClick: (searchTerm: string, searchTermIndex: number) => void;
  className?: string;
  leftAlign?: boolean;
}

export const LazySearchProductsRelatedSearchSection = lazy<React.FC<IProps>>(
  () =>
    import(
      /* webpackChunkName: "styled-search-products-related-search-list" */
      "./SearchProductsRelatedSearchSection"
    )
      .then((m) => ({ default: m.SearchProductsRelatedSearchSection }))
      .catch(handleComponentLoadError)
);
